import image1 from './1.webp';
import image2 from './2.webp';
import image3 from './3.webp';

export const solutionCardImages = [image1, image2, image3];
